module.exports = __webpack_public_path__ + "static/media/Trex.2eb85d94.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/NDF/Inspiration/img/Trex.mp4
// module id = 122
// module chunks = 0